import { useLocation } from "react-router-dom";

export function useLocationState<S>() {
    const location = useLocation();
    const state = location.state as S | null | undefined;
    if (state) return state;
    throw new Error("invalid location state")
}
